"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDisplayConnectionHistoryDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
/** Bounded detailed history. Fleet totals use the compact report endpoints. */
class GetDisplayConnectionHistoryDto {
    displayIds;
    from;
    to;
}
exports.GetDisplayConnectionHistoryDto = GetDisplayConnectionHistoryDto;
__decorate([
    (0, swagger_1.ApiProperty)({
        type: [String],
        maxItems: 10,
        description: "IDs internos o referencias display_id; máximo 10",
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.ArrayMaxSize)(10),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], GetDisplayConnectionHistoryDto.prototype, "displayIds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        format: "date-time",
        description: "Inicio UTC alineado a la hora; intervalo máximo de 31 días",
    }),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], GetDisplayConnectionHistoryDto.prototype, "from", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time", description: "Fin UTC excluido y alineado a la hora" }),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], GetDisplayConnectionHistoryDto.prototype, "to", void 0);
